/**
 * Return a new array with the item moved from one index to another.
 * Negative indexes count from the end.
 *
 * @param array {Array} Source array (not mutated).
 * @param fromIndex {number}.
 * @param toIndex {number}.
 * @returns {Array} Array with the moved item.
 */
const arrayMove = (array, fromIndex, toIndex) => {
  const result = [...array];
  const startIndex = fromIndex < 0 ? result.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < result.length) {
    const endIndex = toIndex < 0 ? result.length + toIndex : toIndex;
    const [item] = result.splice(fromIndex, 1);

    result.splice(endIndex, 0, item);
  }

  return result;
};

export default arrayMove;
